Monitoring.Views ||= {}

class AccountSettings.ReplyBlacklistsView extends Backbone.View
  template: JST["backbone/templates/account_settings/reply_blacklists/reply_blacklists"]

  events :
    'click #new-reply_blacklist': 'onClickNewReplyBlacklist'

  initialize: (@options = {}) ->
    @reply_blacklists = @options.reply_blacklists
    @groups     = @options.groups
    @labelNoneGroup = @options.labelNoneGroup
    @labelAtLeastOneGroup = @options.labelAtLeastOneGroup

  render: =>
    @listView.remove() if @listView
    @editView.remove() if @editView
    @$el.html(@template(@))
    @renderList()
    @

  renderList: =>
    @listView.remove() if @listView
    @listView = new AccountSettings.ReplyBlacklistsListView({
      reply_blacklists: @reply_blacklists,
      groups: @groups
    })
    @$el.find('.list-view-container').append(@listView.render().el)
    @listenTo(@listView, 'edit', @renderEdit)

  onClickNewReplyBlacklist: ->
    @renderEdit()

  renderEdit: (_reply_blacklist = new Monitoring.Models.ReplyBlacklist({content_visibility: 0, active:true})) ->
    @editView.remove() if @editView
    @editView = new AccountSettings.ReplyBlacklistsEditorView({
      reply_blacklist: _reply_blacklist,
      groups: @groups,
      labelNoneGroup: @labelNoneGroup,
      labelAtLeastOneGroup: @labelAtLeastOneGroup
    })
    @$el.find('.edit-view-container').html(@editView.render().el)
    @listenTo(@editView, 'cancel', @render)
    @listenTo(@editView, 'afterSave', @afterSave)
    @editView.updateSaveButtonStatus()

  afterSave: (newRelpyBlacklist) ->
    @reply_blacklists.push(newRelpyBlacklist)
    @render()
